/* unplugin-vue-components disabled */import { render } from "./step.vue?vue&type=template&id=3fba1a80&scoped=true"
import script from "./step.vue?vue&type=script&lang=js"
export * from "./step.vue?vue&type=script&lang=js"

import "./step.vue?vue&type=style&index=0&id=3fba1a80&lang=less&scoped=true"

import exportComponent from "/var/lib/jenkins/workspace/prod-fe.pro/src/fe-pro/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-3fba1a80"]])

export default __exports__